import * as yup from 'yup';

export const AuthorFormValidation = yup.object().shape({
    fullname: yup.string().required('Campo é obrigatória'),
});